import { Button, cn } from "@win-reality/react-ui";
import { ComponentType } from "react";

type ViewToggleButtonProps = {
  isActive: boolean;
  icon: ComponentType<{ className?: string }>;
  onClick: () => void;
  size?: "default" | "small";
  className?: string;
  "data-testid"?: string;
  "data-value"?: string;
  "aria-pressed"?: boolean;
};

function ViewToggleButton({
  isActive,
  icon: Icon,
  onClick,
  size = "default",
  className,
  "data-testid": testId,
  "data-value": value,
  "aria-pressed": pressed,
}: ViewToggleButtonProps) {
  const isSmall = size === "small";
  const buttonSize = isSmall ? "h-9! w-9!" : "h-10! w-10!";
  const iconSize = isSmall ? "h-5 w-5" : "h-6 w-6";

  return (
    <Button
      variant={isActive ? "secondary-flat-dark-outline" : "secondary-flat-dark"}
      size="default-square"
      className={cn(
        buttonSize,
        "p-0 shrink-0",
        isActive && "border-gray-300! dark:border-white! pointer-events-none",
        "border hover:border-gray-400!",
        isActive && "dark:border-white!",
        !isActive && "dark:hover:border-white!",
        className,
      )}
      onClick={onClick}
      data-testid={testId}
      data-value={value}
      aria-pressed={pressed}
    >
      <Icon className={cn(iconSize, "text-black dark:text-white")} />
    </Button>
  );
}

export { ViewToggleButton };
